import React, { FC, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import 'mapbox-gl/dist/mapbox-gl.css';
import routes from './routes';
interface RouteInterface {
  name: string;
  path: string;
  component: React.FC;
}

export interface RouteRootInterface extends RouteInterface {
  routes?: RouteRootInterface[];
}

const renderRoute = (route: RouteRootInterface) => {
  const renderRoutes = (routes: RouteRootInterface[]) => {
    if (routes) {
      return routes.map((routeChild: RouteRootInterface) =>
        renderRoute(routeChild)
      );
    }
    return null;
  };
  const Component = route.component as unknown as () => JSX.Element;
  return (
    <Route path={route.path} key={route.name} element={<Component />}>
      {route.routes && renderRoutes(route.routes)}
    </Route>
  );
};

const Pages: FC = () => {
  const version = process.env.REACT_APP_VERSION || '';
  useEffect(() => {
    const versiontag = document.createElement('meta');
    versiontag.setAttribute('version', version);
    document.getElementsByTagName('head')[0].prepend(versiontag);
  }, [version]);

  return <Routes>{routes.map(renderRoute)}</Routes>;
};

export default Pages;
